import React from 'react';
import { Chip, Stack, Typography, Paper, Box, Divider, Button, FormControlLabel, Switch } from '@mui/material'
import { connectedStatuses } from '../../Config/charge-point-settings';
import { PROTOCOL_LABELS } from '../../ocpp-core/protocol';
import PropTypes from 'prop-types';


const ChargePoint = ({ status, protocol, canConnect, onConnect, onDisconnect, autoReconnect, onToggleAutoReconnect, onAuthorize, onBootNotification, onHeartbeat }) => {
  const isConnected = connectedStatuses.includes(status.status)

  return (
    <Paper sx={{p: 2}}>
      <Box display='flex' alignItems='center' justifyContent='space-between'>
        <Typography variant='h6' color='primary'>CHARGE POINT</Typography>
        <Chip
          size='small'
          icon={<status.icon size={18} style={{ paddingLeft: 6, paddingRight: 3 }} />}
          label={status.text.toUpperCase()}
          color={status.color}
        />
      </Box>
      <Typography variant='caption' color='text.secondary'>{PROTOCOL_LABELS[protocol] ?? PROTOCOL_LABELS['ocpp1.6']}</Typography>
      <Divider sx={{ mt: 0.5, mb: 1.5 }} />
      <Stack spacing={2}>
        {
          isConnected
          ? <Button variant='contained' color='warning' onClick={onDisconnect} fullWidth>Disconnect</Button>
          : <Button disabled={!canConnect} variant='contained' fullWidth onClick={onConnect}>Connect</Button>
        }
        <Button disabled={!isConnected} variant='contained' fullWidth onClick={onAuthorize}>Authorize</Button>
        <Button disabled={!isConnected} variant='contained' fullWidth onClick={onBootNotification}>Boot notification</Button>
        <Button disabled={!isConnected} variant='contained' fullWidth onClick={onHeartbeat}>Heartbeat</Button>
        <FormControlLabel
          control={
            <Switch
              checked={autoReconnect}
              onChange={(e) => onToggleAutoReconnect(e.target.checked)}
            />
          }
          label="Auto Reconnect"
        />
      </Stack>
    </Paper>
  )
}


ChargePoint.propTypes = {
  status: PropTypes.object.isRequired,
  protocol: PropTypes.string,
  canConnect: PropTypes.bool.isRequired,
  onConnect: PropTypes.func.isRequired,
  onDisconnect: PropTypes.func.isRequired,
  autoReconnect: PropTypes.bool.isRequired,
  onToggleAutoReconnect: PropTypes.func.isRequired,
  onAuthorize: PropTypes.func.isRequired,
  onBootNotification: PropTypes.func.isRequired,
  onHeartbeat: PropTypes.func.isRequired,
};

export default ChargePoint
